import { render, staticRenderFns } from "./TenantEditEvents.vue?vue&type=template&id=cb30e524&scoped=true&"
import script from "./TenantEditEvents.vue?vue&type=script&lang=js&"
export * from "./TenantEditEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb30e524",
  null
  
)

export default component.exports